import styled from "styled-components";
import { Link } from "react-router-dom";
import globalStyles from "../../../constants/globalStyles/theme.json";

const { colors, spacing } = globalStyles;

export const Overlay = styled.div<{ $isOpen?: boolean }>`
  position: fixed;
  inset: 0;
  background-color: ${colors.primary.green};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
  clip-path: ${({ $isOpen }) => ($isOpen ? "inset(0)" : "inset(0 0 100% 0)")};
  pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
  transition:
    clip-path 0.38s ease,
    opacity 0.2s ease,
    visibility 0.38s ease;
  z-index: 90;
  overflow-y: auto;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const MenuContent = styled.div<{ $isOpen?: boolean }>`
  display: grid;
  grid-template-rows: auto 1fr auto;
  min-height: 100%;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 128px ${spacing.space24} ${spacing.space32};
  box-sizing: border-box;
`;

export const MenuIntro = styled.div`
  max-width: 330px;
`;

export const Eyebrow = styled.p`
  margin: 0 0 ${spacing.space12};
  color: ${colors.primary.offWhite};
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const Heading = styled.h2`
  margin: 0;
  color: ${colors.primary.offWhite};
  font-size: 1.6rem;
  line-height: 1.25;
`;

export const MenuList = styled.ul`
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 100%;
  margin: ${spacing.space32} 0;
  padding: 0;
  list-style: none;
`;

export const MenuEntry = styled.li`
  border-top: 1px solid rgba(237, 234, 230, 0.3);

  &:last-child {
    border-bottom: 1px solid rgba(237, 234, 230, 0.3);
  }
`;

export const MenuItem = styled(Link)`
  display: grid;
  grid-template-columns: 36px 1fr auto;
  align-items: center;
  gap: ${spacing.space12};
  min-height: 72px;
  color: ${colors.primary.offWhite};
  text-decoration: none;
  font-size: 2rem;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  transition: color 0.2s ease;

  svg {
    width: 22px;
    height: 22px;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary.offWhite};
    outline-offset: -4px;
  }

  &:active {
    color: ${colors.primary.brown};
  }
`;

export const MenuNumber = styled.span`
  color: ${colors.primary.brown};
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
`;

export const MenuLabel = styled.span`
  min-width: 0;
`;

export const MenuFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space16};
`;

export const PhoneLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.space8};
  width: fit-content;
  color: ${colors.primary.offWhite};
  font-size: 1rem;
  text-decoration: none;

  svg {
    width: 18px;
    height: 18px;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary.offWhite};
    outline-offset: 4px;
  }
`;

export const ConsultationLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 54px;
  padding: 0 ${spacing.space16};
  box-sizing: border-box;
  background-color: ${colors.primary.brown};
  color: ${colors.primary.offWhite};
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;

  svg {
    width: 20px;
    height: 20px;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary.offWhite};
    outline-offset: 4px;
  }

  &:active {
    background-color: ${colors.primary.offWhite};
    color: ${colors.primary.green};
  }
`;
